import { Divider, Group, ScrollArea, Stack } from '@mantine/core';
import { t } from 'i18next';
import type { CostByInitiativeResponse } from '../../../../api/financials-client/financials-client.type';
import { useTranslation } from 'react-i18next';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { FilterItem } from '../../../../components/filters/filter-item';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { SmallSquareButton } from '../../../../components/small-square-button/small-square-button';
import { useFinancialsStore } from '../../../../store/financials-store/financials-store';
import {
  resetCostByInitiativeFilters,
  toggleCostByInitiativeId,
  toggleCostByInitiativeTrendLine,
} from '../../../../store/financials-store/financials-store.actions';
import { Text } from '../../../../ui-library/typography/typography';
import { MAX_SELECTED_FILTERS } from '../../constants';
import { getInitiativeInfo } from './cost-by-initiative.helpers';

interface FiltersProps {
  setShow: (show: boolean) => void;
  data?: CostByInitiativeResponse[];
  isPending: boolean;
}

function Filters({ setShow, data, isPending }: FiltersProps) {
  const i18n = useTranslation();
  const { selectedInitiativeIds, selectedTrendLines } = useFinancialsStore((state) => state.filters.costByInitiative);

  const initiativeInfo = getInitiativeInfo(data);

  return (
    <Stack h="100%" style={{ position: 'relative' }}>
      <Group justify="space-between">
        <Text size="medium" weight="medium">
          {i18n.t('common.filters')}
        </Text>
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Group>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <Stack pb={40}>
          <Group justify="space-between">
            <Text size="small" weight="bold">
              {i18n.t('strategy.initiatives.initiatives')}
            </Text>
            <Text size="small" weight="bold">
              {i18n.t('process_analysis.filters.trends')}
            </Text>
          </Group>
          {!isPending && Object.keys(initiativeInfo).length > 0
            ? Object.entries(initiativeInfo).map(([id, name]) => (
                <FilterItem
                  key={id}
                  value={id}
                  label={name}
                  isSelected={selectedInitiativeIds.includes(id)}
                  isSelectedTrends={selectedTrendLines.includes(id)}
                  showTrends={true}
                  selectedCount={selectedInitiativeIds.length}
                  maxSelected={MAX_SELECTED_FILTERS}
                  onToggle={toggleCostByInitiativeId}
                  onTrendsToggle={toggleCostByInitiativeTrendLine}
                />
              ))
            : !isPending && <ContentPlaceholder icon="event_busy" text={t('financials.no_filtered_data')} />}
          <Divider />
        </Stack>
      </ScrollArea>
      <ResetFiltersButton
        onClick={() => resetCostByInitiativeFilters()}
        visible={selectedInitiativeIds.length > 0 || selectedTrendLines.length > 0}
      />
    </Stack>
  );
}

export { Filters };
